// src/utils/whatsapp.js
//
// WhatsApp клиента/должника (он же телефон). Та же проверка, что на бэке
// (backend/src/utils/whatsapp.js): от 9 цифр, пробелы/скобки/дефисы не важны.

export function isValidWhatsapp(raw) {
  return String(raw || '').replace(/\D/g, '').length >= 9;
}
